/* global axios */
import ApiClient from './ApiClient';

class ConversationApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getLabels(conversationID) {
    return axios.get(`${this.url}/${conversationID}/labels`);
  }

  updateLabels(conversationID, labels) {
    return axios.post(`${this.url}/${conversationID}/labels`, { labels });
  }

  getUnreadCounts() {
    return axios.get(`${this.url}/unread_counts`);
  }

  // ADVup: busca de conversa por texto, usada para vincular um atendimento a
  // um compromisso/tarefa da agenda jurídica (a rota já existia no backend —
  // `conversations#search` — mas nenhum cliente daqui a chamava).
  search({ q, page = 1 } = {}) {
    return axios.get(`${this.url}/search`, { params: { q, page } });
  }

  // ADVup: todos os anexos da conversa, para a aba "Mídias e documentos" do
  // painel do contato.
  //
  // Pedido do Dr. Henrique via Victor (2026-08-07): "no Digisac tinha essa aba
  // onde ficavam concentrados todos os documentos da conversa. Quando eu
  // reabria a pasta, eu não precisava ficar rolando a conversa até o início
  // para procurar os documentos para baixar".
  //
  // A ROTA JÁ EXISTIA no backend (`conversations#attachments`, paginada e
  // ordenada) e nenhum cliente daqui a chamava — mesma situação do `search`
  // acima. Não foi preciso mexer em API nem em banco.
  attachments(conversationId, { page = 1 } = {}) {
    return axios.get(`${this.url}/${conversationId}/attachments`, {
      params: { page },
    });
  }

  // Aba "Links". Diferente de `attachments`, esta rota é do Advup: link não é
  // anexo, mora no corpo da mensagem, e sem varredura no servidor só apareceria
  // o que já está carregado na tela.
  links(conversationId) {
    return axios.get(`${this.url}/${conversationId}/links`);
  }
}

export default new ConversationApi();
